import { MixedMartialArtsIcon } from './MixedMartialArtsIcon';

/**
 * author: Google
 * id BF0B21D2-7266-4639-B2C4-24199863849D
 * name mixed-martial-arts
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/mixed-martial-arts.svg
 * tags
 * - Sport 
 */
export const MmaIcon = MixedMartialArtsIcon;
export default MmaIcon